import React from "react";

import CardNumberProps from "./props";
import { formatCardNumber } from "./utils";

export default function CardNumber(props: CardNumberProps): JSX.Element {
  const cardNumber = props.cardNumber;
  const formattedCardNumber = formatCardNumber(cardNumber);

  return <>{formattedCardNumber}</>;
}
